import clsx from 'clsx';
import dom from 'isomorphic-dompurify';

import styles from './InnerHtml.module.scss';

type Props = {
  className?: string;
  html: string;
  allowedTags?: string[];
  allowedAttrs?: string[];
};

export const InnerHtml = ({
  className = '',
  html,
  allowedTags = [],
  allowedAttrs = [],
}: Props) => {
  const formattedHTML = html
    .replace(/\\n/g, '<br />') 
    .replace(/\n/g, '<br />') 
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') 
    .replace(/\*(.*?)\*/g, '<em>$1</em>'); 

  // Очищаем HTML с помощью DOMPurify
  const cleanHTML = dom.sanitize(formattedHTML, {
    ALLOWED_TAGS: [
      'p',
      'font',
      'em',
      'strong',
      'small',
      'sub',
      'sup',
      'ins',
      'samp',
      'abbr',
      'blockquote',
      'dfn',
      'cite',
      'q',
      'kbd',
      'strike',
      'i',
      'b',
      'br',
      'ul',
      'ol',
      'li',
      'pre',
      'a',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'span',
      'time',
      'div',
      'img',
      ...allowedTags,
    ],
    ALLOWED_ATTR: [
      'style',
      'class',
      'itemprop',
      'itemscope',
      'itemtype',
      'datetime',
      'href',
      'src',
      'alt',
      'title',
      'width',
      'height',
      ...allowedAttrs,
    ],
  });

  return (
    <div
      className={clsx(className, styles.content)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: cleanHTML }}
    />
  );
};
